export default __webpack_public_path__ + "static/media/map.1602010b.jpg";